import {
  DeleteAssignmentNoteDocument,
  DeleteAssignmentNoteMutation,
  DeleteAssignmentNoteMutationVariables,
  GetMyNotesByAssignmentIdDocument,
  GetMyNotesByAssignmentIdQuery,
  GetMyNotesByAssignmentIdQueryVariables,
  InsertNoteDocument,
  InsertNoteMutation,
  InsertNoteMutationVariables,
  UpdateAssignmentDocument,
  UpdateAssignmentMutation,
  UpdateAssignmentMutationVariables,
} from '../types';
import { client } from '../../client';

export async function insert(variables: InsertNoteMutationVariables): Promise<{ affected_rows: number }> {
  try {
    const response = await client.mutate<InsertNoteMutation, InsertNoteMutationVariables>({
      mutation: InsertNoteDocument,
      variables,
    });

    return response.data.insert_assignment_notes;
  } catch (e) {
    throw e;
  }
}

export async function getByMyIdAndAssignmentId(
  variables: GetMyNotesByAssignmentIdQueryVariables,
): Promise<Array<{ content: string; created_at?: string }>> {
  try {
    const response = await client.query<GetMyNotesByAssignmentIdQuery, GetMyNotesByAssignmentIdQueryVariables>({
      variables,
      query: GetMyNotesByAssignmentIdDocument,
      fetchPolicy: 'network-only'
    });

    return response.data.assignment_notes;
  } catch (e) {
    throw e;
  }
}
//
export async function deleteNote(variables: DeleteAssignmentNoteMutationVariables): Promise<{ id: string }> {
  try {
    const response = await client.mutate<DeleteAssignmentNoteMutation, DeleteAssignmentNoteMutationVariables>({
      mutation: DeleteAssignmentNoteDocument,
      variables,
    });

    return response.data.delete_assignment_notes_by_pk;
  } catch (e) {
    throw e;
  }
}

export async function updateNote(variables: UpdateAssignmentMutationVariables): Promise<{ content: string }> {
  try {
    const response = await client.mutate<UpdateAssignmentMutation, UpdateAssignmentMutationVariables>({
      mutation: UpdateAssignmentDocument,
      variables,
    });
    return response.data.update_assignment_notes_by_pk;
  } catch (e) {
    throw e;
  }
}
